"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationsCollection_1 = require("../DataModel/Collections/OperationsCollection");
const TemplatedOperation_1 = require("../DataModel/TemplatedOperation");
const namespaces_1 = require("../namespaces");
const JsonLdHelper_1 = require("./JsonLdHelper");
function onTemplateMaterialized(processingState, template, linkIri, operations) {
    tryCreateOperationFrom(processingState, processingState.getVisitedResource(linkIri), template, operations);
}
function onLinkMaterialized(processingState, link, templateIri, operations) {
    tryCreateOperationFrom(processingState, link, processingState.getVisitedResource(templateIri), operations);
}
function tryCreateOperationFrom(processingState, link, template, operations) {
    if (!!link && !!template) {
        processingState.markAsOwned(link.iri);
        processingState.markAsOwned(template.iri);
        if (link !== null && link.type.contains(namespaces_1.hydra.TemplatedLink)) {
            for (const linkOperation of link.supportedOperations) {
                processingState.markAsOwned(linkOperation.iri);
                operations.push(new TemplatedOperation_1.default(linkOperation, template));
            }
        }
    }
}
exports.templatedOperationsExtractor = (operations, processingState) => {
    for (const link of JsonLdHelper_1.JsonLdHelper.validKeys(processingState.processedObject, true)) {
        for (const value of processingState.processedObject[link]) {
            const template = processingState.findRawResource(value["@id"]);
            let processedTemplate = null;
            if (!!template && template["@type"] && template["@type"].indexOf(namespaces_1.hydra.IriTemplate) !== -1) {
                processedTemplate = processingState.getVisitedResource(template["@id"]);
                if (!processedTemplate) {
                    processingState.notifyMaterialized(template["@id"], (state, resource) => onTemplateMaterialized(state, resource, link, operations));
                }
                const processedLink = processingState.getVisitedResource(link);
                if (!processedLink) {
                    processingState.notifyMaterialized(link, (state, resource) => onLinkMaterialized(state, resource, template["@id"], operations));
                }
                tryCreateOperationFrom(processingState, processedLink, processedTemplate, operations);
            }
        }
    }
    return new OperationsCollection_1.default(operations);
};
//# sourceMappingURL=templatedOperationsExtractor.js.map